<template>
  <div>
    <ListEdit
      v-model="localQuestions"
      label="Preguntas de la plantilla"
      @handleAdd="handleAdd"
      @handleRemove="handleRemove"
      :minItems="1"
    >
      <template #header>
        <div class="d-flex align-items-center g-1">
          <div class="row flex-grow-1 g-1 me-2">
            <div class="col-6 text-muted small">Pregunta</div>
            <div class="col-3 text-muted small">Título cargo</div>
            <div class="col-3 text-muted small">Título fecha</div>
          </div>
          <div class="ms-2">
            <b-button
              size="sm"
              variant="outline-success"
              class="me-1 invisible my-0"
            >
              <b-icon icon="plus-circle"></b-icon>
            </b-button>
          </div>
        </div>
      </template>
      <template #default="{ index }">
        <div>
          <div class="d-flex align-items-center mb-2 g-1">
            <div class="row flex-grow-1 g-1 me-2">
              <div class="col-6">
                <input
                  class="form-control form-control-sm"
                  type="text"
                  v-model="localQuestions[index].name"
                  :placeholder="'Pregunta ' + (index + 1)"
                  required
                />
              </div>
              <div class="col-3">
                <input
                  class="form-control form-control-sm"
                  type="text"
                  v-model="localQuestions[index].fieldNameCargo"
                  :placeholder="'Título posición ' + (index + 1)"
                />
              </div>
              <div class="col-3">
                <input
                  class="form-control form-control-sm"
                  type="text"
                  v-model="localQuestions[index].fieldNameDate"
                  :placeholder="'Título fecha ' + (index + 1)"
                />
              </div>
            </div>
            <div class="ms-2">
              <b-button
                v-if="!localQuestions[index].hasSubquestionsConfigured"
                size="sm"
                variant="outline-success"
                @click="activateSubquestions(index)"
                v-b-tooltip.hover.left
                title="Sub-preguntas"
                class="me-1"
              >
                <b-icon icon="plus-circle"></b-icon>
              </b-button>

              <span v-else class="d-inline-flex align-items-center">
                <b-button
                  size="sm"
                  variant="outline-info"
                  @click="toggleSubquestions(index)"
                  :aria-expanded="
                    isSubquestionVisible(index) ? 'true' : 'false'
                  "
                  :aria-controls="'collapse-subquestions-' + index"
                  class="me-1"
                  v-b-tooltip.hover
                  :title="
                    'Sub-preguntas (' +
                    localQuestions[index].subquestions.length +
                    ')'
                  "
                >
                  <b-icon
                    :icon="
                      isSubquestionVisible(index)
                        ? 'chevron-up'
                        : 'chevron-down'
                    "
                  ></b-icon>
                </b-button>
                <b-button
                  v-if="localQuestions[index].subquestions.length === 0"
                  size="sm"
                  variant="outline-danger"
                  @click="deactivateSubquestions(index)"
                  v-b-tooltip.hover
                  title="Desactivar Sub-preguntas (solo si no hay ninguna)"
                  class="me-1"
                >
                  <b-icon icon="x-circle"></b-icon>
                </b-button>
              </span>
            </div>
          </div>

          <b-collapse
            v-if="localQuestions[index].hasSubquestionsConfigured"
            v-model="localQuestions[index].showSubquestions"
            :id="'collapse-subquestions-' + index"
          >
            <b-card class="ms-4 mb-2 bg-light">
              <ListEdit
                label="Sub-preguntas"
                v-model="localQuestions[index].subquestions"
                @handleAdd="handleAddSubquestion(index)"
                @handleRemove="handleRemoveSubquestion(index, $event)"
                :minItems="0"
                add-button-text="Agregar Sub-pregunta"
                class="sub-list-edit"
              >
                <template #header>
                  <div class="row g-1 text-muted small">
                    <div class="col-6">Sub-pregunta</div>
                    <div class="col-3">Título posición</div>
                    <div class="col-3">Título fecha</div>
                  </div>
                </template>
                <template #default="{ index: subIndex }">
                  <div class="row g-1">
                    <div class="col-6">
                      <input
                        class="form-control form-control-sm"
                        type="text"
                        v-model="
                          localQuestions[index].subquestions[subIndex].name
                        "
                        :placeholder="
                          'Sub-pregunta ' + (index + 1) + '.' + (subIndex + 1)
                        "
                        required
                      />
                    </div>
                    <div class="col-3">
                      <input
                        class="form-control form-control-sm"
                        type="text"
                        v-model="
                          localQuestions[index].subquestions[subIndex]
                            .fieldNameCargo
                        "
                        :placeholder="
                          'Título posición ' +
                          (index + 1) +
                          '.' +
                          (subIndex + 1)
                        "
                      />
                    </div>
                    <div class="col-3">
                      <input
                        class="form-control form-control-sm"
                        type="text"
                        v-model="
                          localQuestions[index].subquestions[subIndex]
                            .fieldNameDate
                        "
                        :placeholder="
                          'Título fecha ' + (index + 1) + '.' + (subIndex + 1)
                        "
                      />
                    </div>
                  </div>
                </template>
              </ListEdit>
            </b-card>
          </b-collapse>
        </div>
      </template>
    </ListEdit>

    <div class="d-flex justify-content-end mt-3">
      <b-button
        variant="primary"
        @click="saveQuestions"
        :disabled="localQuestions.length === 0"
        >Guardar Preguntas</b-button
      >
      <AlertDismiss ref="alertDismiss" />
    </div>
  </div>
</template>

<script>
import ListEdit from "@/components/shared/List-edit.vue";
import AlertDismiss from "@/components/shared/Alert-dismiss.vue";

export default {
  name: "StatementQuestionModal",

  components: {
    ListEdit,
    AlertDismiss,
  },

  props: {
    initialQuestions: {
      type: Array,
      required: true,
      default: () => [],
    },
  },

  data() {
    return {
      localQuestions: [],
    };
  },

  watch: {
    initialQuestions: {
      immediate: true,
      handler(newVal) {
        this.localQuestions = JSON.parse(JSON.stringify(newVal));
        if (this.localQuestions.length === 0) {
          this.handleAdd();
        }
      },
    },
  },

  methods: {
    handleAdd() {
      this.localQuestions.push({
        name: null,
        fieldNameCargo: null,
        fieldNameDate: null,
        subquestions: [],
        showSubquestions: false,
        hasSubquestionsConfigured: false,
      });
    },

    handleRemove(index) {
      this.localQuestions.splice(index, 1);
    },

    handleAddSubquestion(parentIndex) {
      if (!this.localQuestions[parentIndex].subquestions) {
        this.$set(this.localQuestions[parentIndex], "subquestions", []);
      }
      this.localQuestions[parentIndex].subquestions.push({
        name: null,
        fieldNameCargo: null,
        fieldNameDate: null,
      });
    },

    handleRemoveSubquestion(parentIndex, subIndex) {
      this.localQuestions[parentIndex].subquestions.splice(subIndex, 1);
    },

    activateSubquestions(index) {
      this.$set(this.localQuestions[index], "hasSubquestionsConfigured", true);
      this.$set(this.localQuestions[index], "showSubquestions", true);
      if (
        !this.localQuestions[index].subquestions ||
        this.localQuestions[index].subquestions.length === 0
      ) {
        this.handleAddSubquestion(index);
      }
    },

    deactivateSubquestions(index) {
      this.$set(this.localQuestions[index], "hasSubquestionsConfigured", false);
      this.$set(this.localQuestions[index], "subquestions", []);
      this.$set(this.localQuestions[index], "showSubquestions", false);
    },

    toggleSubquestions(index) {
      this.$set(
        this.localQuestions[index],
        "showSubquestions",
        !this.localQuestions[index].showSubquestions
      );
    },

    isSubquestionVisible(index) {
      return !!this.localQuestions[index].showSubquestions;
    },

    saveQuestions() {
      this.$emit(
        "update-questions",
        JSON.parse(JSON.stringify(this.localQuestions))
      ); // deep copy
    },
  },
};
</script>
